/**
 * Trạng thái bản ghi kiểm kê quỹ
 */
export default {
  Normal: 0, //  ''
  Saved: 1, //  'Chưa xử lý chênh lệch'
  HandledDiff: 2, //    'Đã xử lý chênh lệch'
};
